import { BRAND } from "../config";

export const PREFERENCE_KEYS = {
  SHOW_ZERO_CHARGES: "show_zero_charges",
};

const storedPreferencesHandler = {
  get: (key: keyof typeof PREFERENCE_KEYS, userCompanyID: string) => {
    let value = JSON.parse(localStorage.getItem(key) ?? "null");

    switch (key) {
      case PREFERENCE_KEYS.SHOW_ZERO_CHARGES: {
        if (value === null) {
          value = userCompanyID === BRAND;
          localStorage.setItem(key, JSON.stringify(value));
        }

        return value;
      }
      default: {
        return value;
      }
    }
  },
  set: (key: keyof typeof PREFERENCE_KEYS, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  clearAll: () => {
    Object.values(PREFERENCE_KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });
  },
};

export default storedPreferencesHandler;
